
import React, { useState } from 'react'
import PivotPointImg from "../../assets/PivitPoint.jpg";



import Header from './Header';
import Footer from './Footer';


const PivotPoint = () => {
    const [language, setLanguage] = useState("english")

    return (

        <div className="w-screen h-full">
            <Header></Header>
            <div className="bg-white/10 backdrop-blur-md m-3 rounded-lg">
                <div className="  px-4 py-5 bg-white/20  ">
                    {/* Hero Image */}
                    <div className="rounded-xl flex justify-center   overflow-hidden shadow-lg">
                        <img
                            src={PivotPointImg}
                            alt="SMA Indicator"
                            className="object-cover h-72 w-full "
                        />
                    </div>

                    {/* Category Tag */}
                    <div className="mt-6">
                        <span className="inline-block bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide">
                            Technical Indicator
                        </span>
                    </div>

                    <div className="w-full  rounded-md p-4 mt-2  flex flex-col items-center justify-between">




                        <h1 className="text-3xl sm:text-4xl font-bold text-black mt-4 leading-tight">
                            Understanding the Pivot Point Indicator
                        </h1>




                        <div className="flex flex-wrap m-4 gap-3">
                            <button
                                onClick={() => setLanguage("english")}
                                className={`p-2 font-bold rounded-md ${language === "english"
                                    ? "bg-blue-500 text-white"
                                    : "bg-blue-200 text-black"
                                    }`}
                            >
                                English
                            </button>

                            <button
                                onClick={() => setLanguage("hindi")}
                                className={`p-2 font-bold rounded-md ${language === "hindi"
                                    ? "bg-blue-500 text-white"
                                    : "bg-blue-200 text-black"
                                    }`}
                            >
                                हिन्दी
                            </button>
                        </div>


                        {language === "english" && (

                            <div>
                                <p className="mt-6 text-black leading-relaxed">
                                    Pivot Point is a technical indicator primarily used to identify key support and resistance levels. It is calculated based on the previous day's high, low, and closing prices to determine potential price levels for the next trading session. Traders use Pivot Points to make trading decisions, set entry and exit points, and gauge market direction. Whether you are new to technical analysis or an experienced trader, understanding Pivot Points can help make your trading decisions more accurate and safer.
                                </p>

                                <div className="w-full">
                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        How to Use Pivot Points in Trading
                                    </h2>

                                    <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                                        <li>
                                            <strong>Open Your Trading Platform:</strong> Log in to your preferred platform (TradingView, Zerodha, Upstox, etc.).
                                        </li>

                                        <li>
                                            <strong>Select an Asset:</strong> Open the chart of the stock, crypto, or currency pair you want to analyze.
                                        </li>

                                        <li>
                                            <strong>Add Pivot Point Indicator:</strong> Go to the <em>Indicators</em> menu and search for <em>Pivot Point</em>. Add it to your chart and observe the main Pivot, R1, R2, S1, S2 levels.
                                        </li>

                                        <li>
                                            <strong>Understand the Levels:</strong>
                                            <br />- Pivot Point → main level to determine market direction.
                                            - R1, R2 → potential resistance levels.
                                            - S1, S2 → potential support levels.
                                        </li>

                                        <li>
                                            <strong>Make Trading Decisions:</strong>
                                            <br />- Price above Pivot Point → bullish signal.
                                            - Price below Pivot Point → bearish signal.
                                            - Use R1, R2, S1, S2 levels for targets or stop-loss.
                                        </li>

                                        <li>
                                            <strong>Combine with Other Indicators:</strong> Use Pivot Points with RSI, MACD, or moving averages to confirm trading decisions.
                                        </li>

                                        <li>
                                            <strong>Trading Tip:</strong> Prices often reverse near the main Pivot, so always confirm entry or exit levels.
                                        </li>
                                    </ol>

                                    <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                                        <li>
                                            <strong>Pros:</strong>
                                            <br />- Clearly identifies support and resistance levels.
                                            <br />- Helps in making trading entries and exits.
                                            <br />- Useful for low-risk trading decisions.
                                            <br />- Can be combined with other indicators for more accurate signals.
                                        </li>

                                        <li>
                                            <strong>Cons:</strong>
                                            <br />- Does not indicate trend strength or direction alone.
                                            <br />- May be less effective during sudden market moves.
                                            <br />- Requires additional indicators for complete trading decisions.
                                        </li>
                                    </ul>

                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        What Pivot Points Can Exactly Do
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>Determine Support and Resistance:</strong> Pivot Points indicate potential reversal or breakout levels.
                                        </li>
                                        <li>
                                            <strong>Guide Entry and Exit:</strong> Use Pivot, R1/R2, S1/S2 levels for entries, targets, and stop-losses.
                                        </li>
                                        <li>
                                            <strong>Gauge Market Direction:</strong> Price above or below Pivot Point signals bullish or bearish movement.
                                        </li>
                                        <li>
                                            <strong>Combine with Other Indicators:</strong> Use Pivot Points with RSI, MACD, or moving averages to strengthen strategy.
                                        </li>
                                        <li>
                                            <strong>Filter Market Noise:</strong> Focus on important levels to recognize potential unexpected moves.
                                        </li>
                                    </ol>

                                    <h2 className="text-2xl font-semibold mt-10 text-black">
                                        When to Use Pivot Point Indicator
                                    </h2>

                                    <ol className="list-disc pl-5 space-y-2 text-black">
                                        <li>
                                            <strong>Identify Support and Resistance:</strong> Make trading decisions at Pivot, R1/R2, S1/S2 levels.
                                        </li>
                                        <li>
                                            <strong>Spot Breakouts or Reversals:</strong> Price breaking or bouncing from Pivot or R/S levels → potential trading signal.
                                        </li>
                                        <li>
                                            <strong>Enhance Trade Systems:</strong> Combine Pivot Points with other technical indicators for refined entries/exits.
                                        </li>
                                        <li>
                                            <strong>Manage Risk:</strong> Set stop-loss and target at key levels to reduce risk.
                                        </li>
                                    </ol>

                                    <h2 className="text-2xl font-semibold text-black">
                                        📈 Generate Pivot Point Signals Using Python
                                    </h2>

                                    <p className="mt-4 text-black leading-relaxed">
                                        You can fetch historical data from <strong>Yahoo Finance</strong> and use <strong>pandas</strong> or other libraries to calculate Pivot Point and its support/resistance levels. A simple example strategy:
                                    </p>

                                    <ul className="list-disc ml-6 mt-3 space-y-2 text-black">
                                        <li>
                                            Price above Pivot Point → bullish signal → consider buying.
                                        </li>
                                        <li>
                                            Price below Pivot Point → bearish signal → consider selling or shorting.
                                        </li>
                                        <li>
                                            Use R1, R2, S1, S2 levels for targets and stop-loss.
                                        </li>
                                    </ul>
                                </div>


                            </div>


                        )}

                        {language === "hindi" && (

                            <div>

                                <div>
                                    <p className="mt-6 text-black leading-relaxed">
                                        Pivot Point एक तकनीकी संकेतक है जो मुख्य रूप से सपोर्ट और रेजिस्टेंस लेवल की पहचान के लिए उपयोग किया जाता है। यह पिछले दिन के हाई, लो और क्लोज़िंग प्राइस के आधार पर अगले ट्रेडिंग सेशन के संभावित प्राइस लेवल्स बताता है। ट्रेडर्स Pivot Point का उपयोग ट्रेडिंग निर्णय लेने, एंट्री और एग्ज़िट पॉइंट्स निर्धारित करने और बाजार की दिशा का अनुमान लगाने के लिए करते हैं। चाहे आप तकनीकी विश्लेषण में नए हों या अनुभवी ट्रेडर, Pivot Point को समझना आपके ट्रेडिंग निर्णय को सटीक और सुरक्षित बना सकता है।
                                    </p>

                                    <div className="w-full">
                                        <h2 className="text-2xl font-semibold mt-10 text-black">
                                            ट्रेडिंग में Pivot Point का उपयोग कैसे करें
                                        </h2>

                                        <ol className="list-decimal ml-6 mt-4 space-y-4 text-black">
                                            <li>
                                                <strong>ट्रेडिंग प्लेटफॉर्म खोलें:</strong> अपने पसंदीदा प्लेटफॉर्म (TradingView, Zerodha, Upstox आदि) में लॉगिन करें।
                                            </li>

                                            <li>
                                                <strong>एसेट चुनें:</strong> उस स्टॉक, क्रिप्टो या करेंसी पेयर का चार्ट खोलें जिसे आप विश्लेषण करना चाहते हैं।
                                            </li>

                                            <li>
                                                <strong>Pivot Point जोड़ें:</strong> <em>Indicators</em> मेन्यू में जाएं और <em>Pivot Point</em> खोजें। इसे अपने चार्ट में जोड़ें और मुख्य Pivot, R1, R2, S1, S2 लेवल्स देखें।
                                            </li>

                                            <li>
                                                <strong>लेवल्स को समझें:</strong>
                                                <br />- Pivot Point → मुख्य स्तर जो बाजार की दिशा तय करने में मदद करता है।
                                                <br />- R1, R2 → संभावित रेजिस्टेंस लेवल।
                                                <br />- S1, S2 → संभावित सपोर्ट लेवल।
                                            </li>

                                            <li>
                                                <strong>ट्रेडिंग निर्णय लें:</strong>
                                                <br />- यदि कीमत Pivot Point के ऊपर है → बुलिश सिग्नल।
                                                - यदि कीमत Pivot Point के नीचे है → बेयरिश सिग्नल।
                                                - R1, R2 या S1, S2 लेवल्स का उपयोग टारगेट या स्टॉप-लॉस के लिए करें।
                                            </li>

                                            <li>
                                                <strong>अन्य संकेतकों के साथ मिलाएं:</strong> Pivot Point को RSI, MACD या मूविंग एवरेज के साथ उपयोग करें ताकि ट्रेडिंग निर्णय अधिक सटीक हों।
                                            </li>

                                            <li>
                                                <strong>ट्रेडिंग टिप:</strong> मुख्य Pivot के पास कीमत अक्सर रिवर्स करती है, इसलिए एंट्री या एग्ज़िट लेवल्स की पुष्टि करें।
                                            </li>
                                        </ol>

                                        <ul className="list-disc ml-6 mt-4 space-y-2 text-black">
                                            <li>
                                                <strong>फायदे (Pros):</strong>
                                                <br />- सपोर्ट और रेजिस्टेंस लेवल स्पष्ट रूप से दिखाता है।
                                                <br />- ट्रेडिंग एंट्री और एग्ज़िट में मदद करता है।
                                                <br />- कम जोखिम वाले ट्रेडिंग निर्णय के लिए उपयोगी।
                                                <br />- अन्य तकनीकी संकेतकों के साथ मिलाकर सटीकता बढ़ाता है।
                                            </li>

                                            <li>
                                                <strong>नुकसान (Cons):</strong>
                                                <br />- ट्रेंड की ताकत या दिशा अकेले नहीं बताता।
                                                <br />- बाज़ार में अचानक मूवमेंट के दौरान सटीक नहीं हो सकता।
                                                <br />- पूर्ण ट्रेडिंग निर्णय के लिए अन्य संकेतकों की आवश्यकता होती है।
                                            </li>
                                        </ul>

                                        <h2 className="text-2xl font-semibold mt-10 text-black">
                                            Pivot Point वास्तव में क्या कर सकता है
                                        </h2>

                                        <ol className="list-disc pl-5 space-y-2 text-black">
                                            <li>
                                                <strong>सपोर्ट और रेजिस्टेंस निर्धारित करना:</strong> Pivot Point प्रमुख स्तरों पर कीमत के रिवर्स या ब्रेकआउट की संभावना बताता है।
                                            </li>
                                            <li>
                                                <strong>ट्रेडिंग एंट्री और एग्ज़िट:</strong> Pivot, R1/R2, S1/S2 लेवल्स का उपयोग एंट्री, टारगेट और स्टॉप-लॉस के लिए किया जा सकता है।
                                            </li>
                                            <li>
                                                <strong>मार्केट डायरेक्शन का अनुमान:</strong> कीमत Pivot Point के ऊपर या नीचे होने पर बुलिश या बेयरिश मूवमेंट का संकेत मिलता है।
                                            </li>
                                            <li>
                                                <strong>अन्य संकेतकों के साथ मिलाना:</strong> Pivot Points को RSI, MACD या मूविंग एवरेज के साथ मिलाकर ट्रेडिंग रणनीति मजबूत करें।
                                            </li>
                                            <li>
                                                <strong>बाजार शोर को फिल्टर करना:</strong> Pivot Points महत्वपूर्ण लेवल्स पर ध्यान केंद्रित करके अप्रत्याशित मूवमेंट को पहचानने में मदद करता है।
                                            </li>
                                        </ol>

                                        <h2 className="text-2xl font-semibold mt-10 text-black">
                                            Pivot Point संकेत का उपयोग कब करें
                                        </h2>

                                        <ol className="list-disc pl-5 space-y-2 text-black">
                                            <li>
                                                <strong>सपोर्ट और रेजिस्टेंस की पहचान:</strong> मुख्य Pivot, R1/R2, S1/S2 लेवल्स पर ट्रेडिंग निर्णय लें।
                                            </li>
                                            <li>
                                                <strong>ब्रेकआउट और रिवर्स संभावनाएं:</strong> कीमत Pivot या R/S लेवल्स को तोड़े या पलटे → संभावित ट्रेडिंग सिग्नल।
                                            </li>
                                            <li>
                                                <strong>ट्रेडिंग सिस्टम को सुधारना:</strong> Pivot Points का उपयोग अन्य तकनीकी संकेतकों के साथ करके एंट्री/एग्ज़िट निर्णय मजबूत करें।
                                            </li>
                                            <li>
                                                <strong>जोखिम प्रबंधन:</strong> प्रमुख लेवल्स पर स्टॉप-लॉस और टारगेट निर्धारित करके जोखिम कम करें।
                                            </li>
                                        </ol>

                                        <h2 className="text-2xl font-semibold text-black">
                                            📈 Generate Pivot Point Signals Using Python
                                        </h2>

                                        <p className="mt-4 text-black leading-relaxed">
                                            आप <strong>Yahoo Finance</strong> से ऐतिहासिक डेटा ला सकते हैं और <strong>pandas</strong> या अन्य लाइब्रेरी का उपयोग करके Pivot Point और उसके सपोर्ट/रेजिस्टेंस लेवल्स की गणना कर सकते हैं। एक सरल उदाहरण रणनीति:
                                        </p>

                                        <ul className="list-disc ml-6 mt-3 space-y-2 text-black">
                                            <li>
                                                कीमत Pivot Point के ऊपर → बुलिश सिग्नल → खरीदारी पर विचार करें।
                                            </li>
                                            <li>
                                                कीमत Pivot Point के नीचे → बेयरिश सिग्नल → बिक्री या शॉर्ट पोज़ीशन पर विचार करें।
                                            </li>
                                            <li>
                                                R1, R2, S1, S2 लेवल्स का उपयोग टारगेट और स्टॉप-लॉस के लिए करें।
                                            </li>
                                        </ul>
                                    </div>

                                </div>


                            </div>

                        )}
                    </div>

                    {/* Intro Paragraph */}


                    {/* Getting Started Section */}


                </div>
                <div className="mt-6 w-full  p-4">


                    {/* <pre className="mt-6 bg-gray-900 text-green-300 p-4 rounded-lg overflow-x-auto text-sm"> */}
                    <pre className="mt-6 bg-gray-900 text-green-300 p-4 rounded-lg overflow-x-auto text-sm sm:text-xs md:text-sm">
                        <code>{`
import yfinance as yf
import pandas as pd

# Fetch historical data for NSE stock (e.g., Reliance)
ticker = "RELIANCE.NS"
data = yf.download(ticker, start="2024-08-01", end="2024-09-01", interval="1d")

# Calculate Pivot Point and support/resistance levels
data['Pivot'] = (data['High'] + data['Low'] + data['Close']) / 3
data['R1'] = 2 * data['Pivot'] - data['Low']
data['S1'] = 2 * data['Pivot'] - data['High']
data['R2'] = data['Pivot'] + (data['High'] - data['Low'])
data['S2'] = data['Pivot'] - (data['High'] - data['Low'])

# Generate simple signals based on Pivot
# Price above Pivot → bullish, Price below Pivot → bearish
data['Signal'] = None
for i in range(len(data)):
    if data['Close'][i] > data['Pivot'][i]:
        data.at[i, 'Signal'] = 'BUY'
    elif data['Close'][i] < data['Pivot'][i]:
        data.at[i, 'Signal'] = 'SELL'
    else:
        data.at[i, 'Signal'] = 'HOLD'

# Display relevant columns
print(data[['Close','Pivot','R1','R2','S1','S2','Signal']].dropna())

`}</code>

                    </pre>

                    {/* Pros and Cons Section */}

                </div>



            </div>
            <Footer></Footer>
        </div>
    );

}

export default PivotPoint